import { render, staticRenderFns } from "./LabelOutInput.vue?vue&type=template&id=665683d0&scoped=true&"
import script from "./LabelOutInput.vue?vue&type=script&lang=ts&"
export * from "./LabelOutInput.vue?vue&type=script&lang=ts&"
import style0 from "./LabelOutInput.vue?vue&type=style&index=0&id=665683d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665683d0",
  null
  
)

export default component.exports